/**
 * Shared Arabic labels for GuestRequest + Task UI.
 *
 * Three surfaces consume these:
 *   - GuestRequestsHubPage (V1.1 global queue)
 *   - LinkTaskModal (V1.1 escalation modal)
 *   - BookingGuestRequestsSection (V1 booking-page section)
 *   - GuestRequestsHistory (Phase 5 cross-booking aggregator)
 *
 * Centralized here to avoid drift when wording changes.
 *
 * Per Phase 1 i18n strategy, GRH territory is Arabic-only. If/when the
 * GRH territory joins the translated surface, replace these constants
 * with t() calls in each consumer — the import boundary makes that easy.
 */

// GuestRequest types (model enum)
export const GR_TYPE_LABELS = {
  cleaning: 'تنظيف',
  equipment: 'تجهيزات',
  transport: 'نقل',
  food: 'طعام',
  early_checkin: 'تسجيل وصول مبكر',
  late_checkout: 'تأخير المغادرة',
  other: 'طلب آخر'
};

// Status labels — covers BOTH GuestRequest statuses (new, in-progress,
// completed, cancelled) AND Task statuses (pending, assigned, in-progress,
// completed, cancelled). Shared values use the same Arabic label for both
// enums, so one map fits. Wording matches locales/ar.js → tasks.status.*
// (canonical codebase wording).
export const GR_STATUS_LABELS = {
  'new': 'جديد',
  'pending': 'قيد الانتظار',
  'assigned': 'تم التعيين',
  'in-progress': 'قيد التنفيذ',
  'completed': 'مكتمل',
  'cancelled': 'ملغي'
};

// GuestRequest priority (2-level enum)
export const GR_PRIORITY_LABELS = {
  normal: 'عادية',
  urgent: 'عاجلة'
};
